"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneOffsetOrDefault = getTimezoneOffsetOrDefault;
const date_fns_tz_1 = require("date-fns-tz");
const value_checkers_1 = require("../value-checkers");
const getAdjustedTimezone_1 = require("./getAdjustedTimezone");
function getTimezoneOffsetOrDefault(timezone, date) {
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(timezone);
    const offset = (0, date_fns_tz_1.getTimezoneOffset)(adjustedTimezone, date);
    if ((0, value_checkers_1.isUndefinedOrNull)(offset) || Number.isNaN(offset)) {
        console.error(`Timezone "${adjustedTimezone}" not supported. Date: "${date}", Offset: "${offset}"`);
        return 0;
    }
    return offset;
}
//# sourceMappingURL=getTimezoneOffsetOrDefault.js.map